define([
    // ここに書く
    'app/notice/view/NoticePage',
    // ここまで
], function () { });